// ---------- import React Packs
import React from 'react';
// import * as RN from 'react-native-web';
import * as RN from 'react-native';

// ---------- import Variables Pack
import { create } from 'zustand';

// ---------- import SVG Pack
import Svg from 'react-native-svg';
import * as SvgObj from 'react-native-svg';

// ---------- set Caps Inputs
const useRoutes = create(() => ({
  currRoute: 'terms',
}));
const initCt = {
  longString: 'aaa',
  true: 'true',
};
const screensArr = [
  {
    // ---------- set Caps Inputs
    screenData: { path: 'terms', name: 'Home' },

    Screen: (...args) => {
      // ---------- set Caps Inputs
      const arrStyles = [
        { backgroundColor: 'white' },
        { flex: 1 },
        { padding: 30 },
      ];
      const children = [
        (...args) => {
          // ---------- set Caps Inputs
          const arrProps = [{}];
          const arrStyles = [
            { backgroundColor: 'transparent' },
            { padding: 30 },
            { flex: 1 },
          ];
          const varPath = 'true';
          const varValue = 'true';
          const children = [
            (...args) => {
              // ---------- set Caps Inputs
              const arrProps = [{}];
              const arrStyles = [
                { flexDirection: 'row' },
                { alignContent: 'center' },
                { flexWrap: 'wrap' },
                { height: 40 },
              ];
              const children = [
                () => {
                  // ---------- set Caps Inputs
                  const SvgComponent = props => (
                    <Svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={22}
                      height={19}
                      fill="red"
                      viewBox="0 0 22 19"
                      {...props}
                    >
                      
                      <Path
                        {...props}
                        d="M10.463.537a1.833 1.833 0 0 1 0 2.593L6.259 7.333h13.908a1.833 1.833 0 0 1 0 3.667H6.259l4.204 4.204a1.833 1.833 0 0 1-2.593 2.592L.537 10.463a1.833 1.833 0 0 1 0-2.593L7.87.537a1.833 1.833 0 0 1 2.593 0Z"
                        clipRule="evenodd"
                      />
                    </Svg>
                  );
                  // const svgOriginal = "<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.463 0.536971C11.179 1.25293 11.179 2.41373 10.463 3.1297L6.25939 7.33333H20.1667C21.1792 7.33333 22 8.15415 22 9.16667C22 10.1792 21.1792 11 20.1667 11H6.25939L10.463 15.2036C11.179 15.9196 11.179 17.0804 10.463 17.7964C9.74707 18.5123 8.58627 18.5123 7.8703 17.7964L0.536971 10.463C-0.17899 9.74707 -0.17899 8.58627 0.536971 7.8703L7.8703 0.536971C8.58627 -0.17899 9.74707 -0.17899 10.463 0.536971Z" fill="#0F427F"/> </svg>";
                  const iptHeight = 16;
                  const iptWidth = 16;
                  let iptFill = 'darkblue';

                  const {
                    Defs,
                    Stop,
                    Path,
                    LinearGradient,
                    G,
                    Circle,
                    Rect,
                  } = SvgObj;

                  // ---------- set Vars (If Exists)
                  const [condVar, varValue] =
                    getVarValue(iptFill);
                  if (condVar) iptFill = varValue;

                  return (
                    <SvgComponent
                      fill={iptFill}
                      width={iptWidth}
                      height={iptHeight}
                    />
                  );
                },
                (...args) => {
                  // ---------- set Caps Inputs
                  const arrProps = [{}];
                  const arrStyles = [
                    { width: 10 },
                  ];
                  const varPath = 'true';
                  const varValue = 'true';
                  const children = [
                    () => {
                      return <></>;
                    },
                  ];

                  // ---------- set Arguments (If Exists)
                  let getValue = useData(ct =>
                    pathSel(ct, varPath)
                  );
                  const checkArgs =
                    varPath.startsWith('#');
                  if (checkArgs)
                    getValue = argSel(
                      args,
                      varPath
                    );

                  // ---------- set Conditional Element Render
                  const condRender =
                    getValue === varValue;

                  // ---------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStyles);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <>
                      {!condRender && <></>}
                      {condRender && (
                        <RN.View style={[stl]}>
                          {children.map(
                            (Item, idx) => (
                              <Item
                                key={idx}
                                {...args}
                              />
                            )
                          )}
                        </RN.View>
                      )}
                    </>
                  );
                },
                (...args) => {
                  // ---------- set Capsules Inputs
                  const arrProps = [{}];
                  const arrStls = [
                    { color: 'darkblue' },
                    { fontWeight: 'bold' },
                  ];
                  let children = 'Tela de Início';

                  // ---------- set Arguments Values (If Exists)
                  const checkArgs =
                    children.startsWith('#');
                  if (checkArgs)
                    children = argSel(
                      args,
                      children
                    );

                  // ---------- set Variables Values (If Exists)
                  const [condVar, varValue] =
                    getVarValue(children);
                  if (condVar)
                    children = varValue;

                  // ------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStls);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <RN.Text {...allProps} />
                  );
                },
              ];
              const arrFunctions = [
                (...args) => {
                  const url =
                    'https://investtv.com.br/tap';
                  const type = '_self';

                  window.open(url, type);
                },
              ];

              // ---------- set Variables Styles (If Exists)
              const stl = getStlValues(arrStyles);

              // ---------- set Actions
              const btn = () => {
                const callFn = async () => {
                  for (const currFunc of arrFunctions)
                    await currFunc(...args);
                };
                callFn().catch(err =>
                  console.log({ err })
                );
              };

              // ------- set User Element Properties (If Exists)
              const userElProps = {};

              for (const object of arrProps) {
                for (const keyProp in object) {
                  const valueProp =
                    object[keyProp];
                  userElProps[keyProp] =
                    valueProp;
                }
              }

              const allProps = {
                style: [stl],
                onPress: btn,
                ...userElProps,
              };

              // ---------- set Render
              return (
                <RN.Pressable {...allProps}>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.Pressable>
              );
            },
            (...args) => {
              // ---------- set Caps Inputs
              const children = [
                (...args) => {
                  // ---------- set Capsules Inputs
                  const arrProps = [{}];
                  const arrStls = [
                    { fontSize: 26 },
                    { fontWeight: 'bold' },
                  ];
                  let children = 'Termos de Uso';

                  // ---------- set Arguments Values (If Exists)
                  const checkArgs =
                    children.startsWith('#');
                  if (checkArgs)
                    children = argSel(
                      args,
                      children
                    );

                  // ---------- set Variables Values (If Exists)
                  const [condVar, varValue] =
                    getVarValue(children);
                  if (condVar)
                    children = varValue;

                  // ------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStls);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <RN.Text {...allProps} />
                  );
                },
                (...args) => {
                  // ---------- set Caps Inputs
                  const arrProps = [{}];
                  const arrStyles = [
                    { height: 30 },
                  ];
                  const varPath = 'true';
                  const varValue = 'true';
                  const children = [
                    () => {
                      return <></>;
                    },
                  ];

                  // ---------- set Arguments (If Exists)
                  let getValue = useData(ct =>
                    pathSel(ct, varPath)
                  );
                  const checkArgs =
                    varPath.startsWith('#');
                  if (checkArgs)
                    getValue = argSel(
                      args,
                      varPath
                    );

                  // ---------- set Conditional Element Render
                  const condRender =
                    getValue === varValue;

                  // ---------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStyles);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <>
                      {!condRender && <></>}
                      {condRender && (
                        <RN.View style={[stl]}>
                          {children.map(
                            (Item, idx) => (
                              <Item
                                key={idx}
                                {...args}
                              />
                            )
                          )}
                        </RN.View>
                      )}
                    </>
                  );
                },
                () => (
                  <RN.Text>{`O serviço Options é fornecido a você pela InvestTv, uma empresa brasileira inscrita no Cadastro Nacional de Pessoas Jurídicas (CNPJ/MF) com o número 48.129.874/0001-70\ne sediada à Rua Dr Eduardo de Souza Aranha, 67, CEP  04543-120 – São Paulo, SP.\n\n1– INFORMAÇÕES GERAIS\nA Options é uma empresa cujo objetivo é auxiliar o investidor que opera no mercado de opções brasileiro, desde a simulação até a execução de suas operações na bolsa. A aplicação possui uma interface simples e objetiva que ajuda o trader a focar em seus objetivos, fornecendo informações e dados financeiros relevantes, juntamente com cálculos baseados em preferências individuais, simplificando assim a abordagem do mercado de opções.\nAo utilizar a Options, é necessário que você esteja plenamente ciente e concorde com nossos Termos de Serviço. Portanto, ao realizar seu cadastro e optar por assinar nossos serviços, consideraremos que VOCÊ, nosso usuário, compreendeu e aceitou os presentes Termos de Serviço.\nDe acordo com a legislação vigente, VOCÊ somente poderá aceitar estes Termos de Serviço e, consequentemente, utilizar a Options se for maior de 18 anos e legalmente capaz, conforme os artigos 1º, 3º e 4º do Código Civil Brasileiro de 2002.\nÉ importante que VOCÊ esteja ciente de que estamos constantemente aprimorando nosso sistema e os serviços que oferecemos. Isso pode resultar na descontinuação de determinados serviços ou na inclusão de novas funcionalidades na plataforma. Portanto, é de sua responsabilidade manter-se informado sobre as condições estabelecidas nestes Termos de Serviço, uma vez que eles estarão sujeitos a revisões e atualizações regulares.\n\n2 – USO DO SERVIÇO, PROPRIEDADE INTELECTUAL E CONTEÚDO DOS SERVIÇOS\n\nPara viabilizar a prestação dos serviços oferecidos pela Options e aprimorar sua experiência em nossa plataforma, será necessário que VOCÊ forneça alguns dados pessoais. Esses dados devem ser sempre precisos, corretos, atualizados e verídicos, e serão tratados pela Options exclusivamente para atender a finalidades específicas, em conformidade com nossa Política de Privacidade, disponível em: https://options.com.br/politica-de-privacidade/\n\nA plataforma Options e todo o seu conteúdo são destinados exclusivamente para uso pessoal, não comercial. Os direitos de propriedade intelectual da plataforma e de suas funcionalidades pertencem exclusivamente à Options Tecnologia Ltda. Portanto, é expressamente proibida a comercialização, reprodução, modificação, publicação ou distribuição, sob qualquer título ou forma, da totalidade ou parte das informações oferecidas pela Options, após a assinatura de nossos serviços.\n\nDa mesma forma, a menos que VOCÊ tenha autorização expressa da Options, é terminantemente proibido utilizar qualquer uma das marcas registradas, marcas comerciais, marcas de serviços, logotipos, nomes de domínio e outras características de marca de propried\n\nade da Options Tecnologia Ltda.\n\nDurante sua assinatura, a Options concede a VOCÊ uma licença limitada, não exclusiva e não transferível para acessar a plataforma. Com exceção da licença limitada descrita anteriormente, nenhum outro direito, titularidade ou participação lhe é concedido.\n\nA Options não presta serviço de consultoria de investimentos ou de produtos financeiros, nem oferece recomendações quanto à rentabilidade, liquidez, adequação ou risco. Ao assinar nossos serviços, saiba que os mesmos possuem caráter informativo. Publicamos informações sobre tendências nos mercados de ações, notícias financeiras, estratégias de negócios e economia global. Essas informações não devem ser interpretadas como recomendações financeiras, legais, fiscais, contábeis ou de qualquer outra natureza. A Options não possui qualquer responsabilidade por eventuais prejuízos causados pelo uso das informações disponibilizadas na plataforma.\n\nAo assinar os serviços, VOCÊ concorda em:\n\na) Não acessar (nem tentar acessar) o serviço por qualquer meio que não seja através da interface fornecida pela plataforma.\n\nb) Não acessar (nem tentar acessar) o serviço por meio de meios automatizados.\n\nc) Não participar de nenhuma atividade que interfira ou interrompa o funcionamento do serviço (ou servidores e redes conectados ao serviço).\n\nd) Não reproduzir, duplicar, copiar, vender, comercializar ou revender o serviço para qualquer finalidade.\n\n\n3 – PERÍODO DE UTILIZAÇÃO GRATUITA\n\nSua assinatura na Options poderá começar com um período de utilização gratuita, o qual terá duração de trinta dias e tem a finalidade de permitir que novos e potenciais clientes experimentem o serviço.\n\nA liberação da utilização gratuita é determinada pela Options a seu exclusivo critério e poderá ser revogada a qualquer momento caso VOCÊ deixe de estar qualificado para receber este benefício.\n\nA qualificação do cliente ao período de utilização gratuita é determinada pela Options e poderá ser limitada para evitar abusos do período de utilização gratuita, o que significa que a Options reserva o direito de revogar a utilização gratuita e suspender sua conta se verificarmos que você não está qualificado.\n\nApós o período de utilização gratuita, caso VOCÊ aceite definitivamente assinar os serviços Options, será faturado o valor do plano contratado por VOCÊ, através da forma de pagamento incluída na plataforma. Para consultar o preço da assinatura e a data de término do seu período de utilização gratuita, acesse "Minha Conta" na sua área logada.\n\n4 – ASSINATURA\n\nA Options fornece planos de assinatura mensal ou anual. Se o seu plano for mensal, ele será renovado a cada mês até que seja cancelado, e se for anual, ele será renovado a cada ano até que seja cancelado.\n\nPara assinar os serviços oferecidos pela Options, você precisa fornecer uma forma de pagamento atual, válida e aceita, que poderá ser atualizada ocasionalmente.\n\nComo assinante, VOCÊ concorda que serão cobrados no seu cartão de crédito ou debitados na sua conta bancária os preços relativos à sua assinatura, seja ela mensal ou anual.\n\n5 – PREÇOS, FORMAS DE PAGAMENTO E COBRANÇA\n\nPlano Mensal\n\nO preço da assinatura mensal será cobrado mensalmente, da forma de pagamento indicada por VOCÊ na plataforma, no dia correspondente ao início do período de pagamento da assinatura. Em alguns casos, a data de pagamento poderá ser alterada. Por exemplo, se a forma de pagamento não puder ser cobrada ou se a assinatura paga começou em um dia que não existe em um determinado mês. Acesse a página "Minha Conta" na sua área logada para ver a data do próximo pagamento.\n\nPlano Anual\n\nO preço da assinatura anual será cobrado anualmente, da forma de pagamento indicada por VOCÊ na plataforma, no dia correspondente ao início do período de pagamento da assinatura. A taxa anual informada no momento da compra será cobrada de uma vez. Acesse a página "Minha Conta" para ver a data do próximo pagamento.\n\nVocê poderá alterar a forma de pagamento acessando a plataforma, na aba "Minha Conta". Ao alterar a sua forma de pagamento, você nos autoriza a, automaticamente, alterar a forma de cobrança, bem como reconhece que continua responsável por todos os valores não faturados.\n\nCaso o pagamento não possa ser faturado, seja por motivo de expiração, fundos insuficientes ou outro, e você não altere a sua forma de pagamento, ou cancele a sua conta, poderemos suspender seu acesso\n\n ao serviço até obtermos uma forma de pagamento válida.\n\nOcasionalmente, poderemos alterar nossos Planos e seus respectivos preços. No entanto, todas as alterações efetuadas nos preços ou assinaturas do serviço somente serão aplicadas 30 dias após a notificação enviada a VOCÊ. Para assinantes no Brasil, os preços da assinatura poderão ser ajustados automaticamente a cada ano ou com maior frequência, conforme permitido pela legislação vigente e segundo o Índice Geral de Preços do Mercado (IGP-M) publicado pela Fundação Getúlio Vargas ou outro índice equivalente aplicável ao serviço.6 – LIMITAÇÃO DE USO\n\nÉ vedado ao assinante Options:\n\n(i) Copiar, ceder, sublicenciar, vender, dar em locação ou em garantia, reproduzir, doar, alienar de qualquer forma, transferir total ou parcialmente, sob quaisquer modalidades, gratuita ou onerosamente, provisória ou permanentemente, o software que compreende a Plataforma, assim como seus módulos, partes, manuais ou quaisquer outros direitos de propriedade intelectual da Options, assim como as informações relativas a estes direitos;\n\n(ii) Promover ou permitir que seja promovida descompilação, desmontagem ou engenharia reversa do software que compreende a Plataforma no todo ou em parte, incluído, mas não se limitando às funcionalidades do Site e/ou da Plataforma ou desenvolver novo software e/ou aplicativos com base nas informações extraídas do Site ou da Plataforma, ou ainda, com base nas informações contidas nos documentos e dados inseridos no Site ou na Plataforma;\n\n(iii) Empregar softwares, técnicas e/ou artifícios com o intuito de utilizar indevidamente o Site, o software ou a Plataforma para práticas nocivas à Options ou a terceiros, tais como exploits, spamming, flooding, spoofing, crashing, root kits, etc.;\n\n(iv) Reproduzir, adaptar, modificar e/ou empregar, no todo ou em parte, para qualquer fim, o software ou qualquer conteúdo do Site ou da Plataforma sem a autorização expressa da Options;\n\n(v) Publicar ou transmitir qualquer arquivo que contenha vírus, worms, cavalos de tróia ou qualquer outro programa contaminante ou destrutivo, ou que de outra forma possa interferir no bom funcionamento do Site, Plataforma ou do software que compreende a Plataforma;\n\n(vi) Utilizar o software, Site ou Plataforma para finalidade diversa daquela para a qual foi disponibilizado pela Options;\n\n(vii) Divulgar, utilizar ou modificar indevidamente os dados de outros Usuários; e,\n\n(viii) Permitir o uso não autorizado da Plataforma, do software ou do Site para benefício de terceiros.\n\n7 – CANCELAMENTO\n\nPlano Mensal\n\nVocê pode cancelar sua assinatura mensal da Options quando desejar e continuará a ter acesso ao serviço até o fim do período mensal de faturamento.\n\nPara cancelar, acesse a página "Minha Conta" e siga as instruções de cancelamento.\n\nSe você cancelar sua assinatura, sua conta será automaticamente encerrada ao fim do período de cobrança em andamento.\n\nEm conformidade com a legislação vigente, a Options não oferece reembolsos ou créditos por períodos de assinatura utilizados parcialmente.\n\nPlano Anual\n\nVocê pode cancelar sua assinatura anual da Options quando desejar e continuará a ter acesso ao serviço da Options até o fim do período mensal de faturamento.\n\nO cancelamento da assinatura anual não dará direito ao reembolso integral do que foi pago, sendo objeto de estorno o valor proporcional ao período utilizado conforme plano mensal equivalente e com a aplicação de multa correspondente a 10% (dez por cento) sobre o total do plano contratado.\n\nO reemb\n\nolso será realizado através de depósito em conta bancária, em até 60 (sessenta) dias após a solicitação.\n\nIndependentemente do plano contratado, em conformidade com a legislação vigente, em até 7 (sete) dias após a compra do plano de serviços, em caso de desistência da contratação, você pode solicitar o cancelamento. Neste caso, o reembolso será integral e realizado através de estorno no cartão de crédito no qual a compra foi efetuada, em até 60 (sessenta) dias após a solicitação.\n\n"AO USUÁRIO FINAL declara, neste ato, estar ciente e concordar com os termos de uso e condições a seguir:\n\nA Options poderá, a qualquer momento, cancelar a sua assinatura se:\n\na) VOCÊ tiver violado qualquer cláusula deste Termo de Serviço;\n\nb) For exigido à Options por autoridade legal;\n\nc) O fornecimento dos serviços ao usuário pela Options já não for, a critério da empresa, comercialmente viável.\n\n9 – SEGURANÇA DA CONTA E SENHAS DO USUÁRIO\n\nA Options tem como compromisso assegurar que as informações pessoais dos seus usuários e potenciais usuários sejam armazenadas de forma a lhes garantir proteção, privacidade, integridade, disponibilidade e confidencialidade. Para isso, empregamos as melhores práticas de segurança da informação, visando reduzir a vulnerabilidade de incidentes em nossos ambientes digitais.\n\nNo entanto, a segurança das suas informações pessoais também depende da segurança do seu computador, dispositivo ou rede, assim como do nível de segurança que VOCÊ utiliza para proteger seus dados de autenticação (login e senha).\n\nPortanto, VOCÊ concorda e compreende que é sua responsabilidade pessoal gerenciar suas informações, mantendo a confidencialidade das senhas associadas a qualquer conta que VOCÊ utilize para acessar nossos serviços. Todas as atividades realizadas em sua conta são de sua total e exclusiva responsabilidade.\n\nCaso VOCÊ tome conhecimento de qualquer uso não autorizado de sua senha ou conta, solicitamos que nos comunique imediatamente por meio dos seguintes e-mails: contato@options.com.br ou privacidade@options.com.br, para que possamos tomar as medidas adequadas.\n\n10 – PRIVACIDADE E INFORMAÇÕES PESSOAIS\n\nA Options é uma plataforma comprometida com a segurança e a privacidade dos dados pessoais de seus clientes e potenciais clientes, bem como com a transparência no tratamento dessas informações. Para obter mais informações sobre nossas práticas de proteção de dados pessoais, consulte nossa Política de Privacidade disponível em: https://options.com.br/politica-de-privacidade/\n\nAo se cadastrar e optar por assinar nossos serviços, VOCÊ será questionado sobre seu consentimento para o tratamento de seus dados pessoais. Ao concordar, consideraremos que VOCÊ está de acordo e consente de maneira livre, inequívoca e informada com o tratamento de seus dados pessoais pela Options.\n\n11 – COMUNICAÇÕES ELETRÔNICAS\n\nMantenha seu e-mail de cadastro sempre atualizado e correto, pois o utilizaremos como meio de comunicação para fornecer informações relacionadas à sua conta, como autorizações de pagamento, cobranças, confirmação de alterações de senha ou forma de pagamento, e notificações.\n\nNão enviamos solicitações de dados pessoais, senhas ou códigos de segurança por e-mail. Também não solicitamos por e-mail a instalação de programas ou atualizações de aplicativos. Caso suspeite de algum e-mail recebido em nome da Options solicitando informações sigilosas, DESCONFIE e nos comunique imediatamente por meio do e-mail: privacidade@options.com.br, para que possamos tomar as medidas adequadas.\n\n12 – LEGISLAÇÃO APLICÁVEL E FORO\n\nO presente Termo de Serviço é regido pela legislação da República Federativa do Brasil. O foro da Comarca de São Paulo – SP é eleito como responsável por dirimir reclamações ou controvérsias decorrentes do mesmo.`}</RN.Text>
                ),
              ];

              // ---------- set Render
              return (
                <RN.ScrollView>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.ScrollView>
              );
            },
          ];

          // ---------- set Arguments (If Exists)
          let getValue = useData(ct =>
            pathSel(ct, varPath)
          );
          const checkArgs =
            varPath.startsWith('#');
          if (checkArgs)
            getValue = argSel(args, varPath);

          // ---------- set Conditional Element Render
          const condRender =
            getValue === varValue;

          // ---------- set Variables Styles (If Exists)
          const stl = getStlValues(arrStyles);

          // ------- set User Element Properties (If Exists)
          const userElProps = {};

          for (const object of arrProps) {
            for (const keyProp in object) {
              const valueProp = object[keyProp];
              userElProps[keyProp] = valueProp;
            }
          }

          const allProps = {
            style: [stl],
            children,

            ...userElProps,
          };

          // ---------- set Render
          return (
            <>
              {!condRender && <></>}
              {condRender && (
                <RN.View style={[stl]}>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.View>
              )}
            </>
          );
        },
      ];
      const arrFunctions = [() => {}];

      // ---------- call Functions (If Exists)
      React.useEffect(() => {
        const callFn = async () => {
          for (const currFunc of arrFunctions)
            await currFunc(...args);
        };
        callFn().catch(err =>
          console.log({ err })
        );
      }, []);

      // ---------- set Variables Styles (If Exists)
      const stl = getStlValues(arrStyles);

      // ---------- set Render
      return (
        <RN.View style={[stl]}>
          {children.map((Item, idx) => (
            <Item key={idx} />
          ))}
        </RN.View>
      );
    },
  },
  {
    // ---------- set Caps Inputs
    screenData: { path: 'policy', name: 'Home' },

    Screen: (...args) => {
      // ---------- set Caps Inputs
      const arrStyles = [
        { backgroundColor: 'white' },
        { flex: 1 },
        { padding: 30 },
      ];
      const children = [
        (...args) => {
          // ---------- set Caps Inputs
          const arrProps = [{}];
          const arrStyles = [
            { backgroundColor: 'transparent' },
            { padding: 30 },
            { flex: 1 },
          ];
          const varPath = 'true';
          const varValue = 'true';
          const children = [
            (...args) => {
              // ---------- set Caps Inputs
              const arrProps = [{}];
              const arrStyles = [
                { flexDirection: 'row' },
                { alignContent: 'center' },
                { flexWrap: 'wrap' },
                { height: 40 },
              ];
              const children = [
                () => {
                  // ---------- set Caps Inputs
                  const SvgComponent = props => (
                    <Svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={22}
                      height={19}
                      fill="red"
                      viewBox="0 0 22 19"
                      {...props}
                    >
                      
                      <Path
                        {...props}
                        d="M10.463.537a1.833 1.833 0 0 1 0 2.593L6.259 7.333h13.908a1.833 1.833 0 0 1 0 3.667H6.259l4.204 4.204a1.833 1.833 0 0 1-2.593 2.592L.537 10.463a1.833 1.833 0 0 1 0-2.593L7.87.537a1.833 1.833 0 0 1 2.593 0Z"
                        clipRule="evenodd"
                      />
                    </Svg>
                  );
                  // const svgOriginal = "<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg"> <path fill-rule="evenodd" clip-rule="evenodd" d="M10.463 0.536971C11.179 1.25293 11.179 2.41373 10.463 3.1297L6.25939 7.33333H20.1667C21.1792 7.33333 22 8.15415 22 9.16667C22 10.1792 21.1792 11 20.1667 11H6.25939L10.463 15.2036C11.179 15.9196 11.179 17.0804 10.463 17.7964C9.74707 18.5123 8.58627 18.5123 7.8703 17.7964L0.536971 10.463C-0.17899 9.74707 -0.17899 8.58627 0.536971 7.8703L7.8703 0.536971C8.58627 -0.17899 9.74707 -0.17899 10.463 0.536971Z" fill="#0F427F"/> </svg>";
                  const iptHeight = 16;
                  const iptWidth = 16;
                  let iptFill = 'darkblue';

                  const {
                    Defs,
                    Stop,
                    Path,
                    LinearGradient,
                    G,
                    Circle,
                    Rect,
                  } = SvgObj;

                  // ---------- set Vars (If Exists)
                  const [condVar, varValue] =
                    getVarValue(iptFill);
                  if (condVar) iptFill = varValue;

                  return (
                    <SvgComponent
                      fill={iptFill}
                      width={iptWidth}
                      height={iptHeight}
                    />
                  );
                },
                (...args) => {
                  // ---------- set Caps Inputs
                  const arrProps = [{}];
                  const arrStyles = [
                    { width: 10 },
                  ];
                  const varPath = 'true';
                  const varValue = 'true';
                  const children = [
                    () => {
                      return <></>;
                    },
                  ];

                  // ---------- set Arguments (If Exists)
                  let getValue = useData(ct =>
                    pathSel(ct, varPath)
                  );
                  const checkArgs =
                    varPath.startsWith('#');
                  if (checkArgs)
                    getValue = argSel(
                      args,
                      varPath
                    );

                  // ---------- set Conditional Element Render
                  const condRender =
                    getValue === varValue;

                  // ---------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStyles);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <>
                      {!condRender && <></>}
                      {condRender && (
                        <RN.View style={[stl]}>
                          {children.map(
                            (Item, idx) => (
                              <Item
                                key={idx}
                                {...args}
                              />
                            )
                          )}
                        </RN.View>
                      )}
                    </>
                  );
                },
                (...args) => {
                  // ---------- set Capsules Inputs
                  const arrProps = [{}];
                  const arrStls = [
                    { color: 'darkblue' },
                    { fontWeight: 'bold' },
                  ];
                  let children = 'Tela de Início';

                  // ---------- set Arguments Values (If Exists)
                  const checkArgs =
                    children.startsWith('#');
                  if (checkArgs)
                    children = argSel(
                      args,
                      children
                    );

                  // ---------- set Variables Values (If Exists)
                  const [condVar, varValue] =
                    getVarValue(children);
                  if (condVar)
                    children = varValue;

                  // ------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStls);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <RN.Text {...allProps} />
                  );
                },
              ];
              const arrFunctions = [
                (...args) => {
                  const url =
                    'https://investtv.com.br/tap';
                  const type = '_self';

                  window.open(url, type);
                },
              ];

              // ---------- set Variables Styles (If Exists)
              const stl = getStlValues(arrStyles);

              // ---------- set Actions
              const btn = () => {
                const callFn = async () => {
                  for (const currFunc of arrFunctions)
                    await currFunc(...args);
                };
                callFn().catch(err =>
                  console.log({ err })
                );
              };

              // ------- set User Element Properties (If Exists)
              const userElProps = {};

              for (const object of arrProps) {
                for (const keyProp in object) {
                  const valueProp =
                    object[keyProp];
                  userElProps[keyProp] =
                    valueProp;
                }
              }

              const allProps = {
                style: [stl],
                onPress: btn,
                ...userElProps,
              };

              // ---------- set Render
              return (
                <RN.Pressable {...allProps}>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.Pressable>
              );
            },
            (...args) => {
              // ---------- set Caps Inputs
              const children = [
                (...args) => {
                  // ---------- set Capsules Inputs
                  const arrProps = [{}];
                  const arrStls = [
                    { fontSize: 26 },
                    { fontWeight: 'bold' },
                  ];
                  let children =
                    'Política de Privacidade';

                  // ---------- set Arguments Values (If Exists)
                  const checkArgs =
                    children.startsWith('#');
                  if (checkArgs)
                    children = argSel(
                      args,
                      children
                    );

                  // ---------- set Variables Values (If Exists)
                  const [condVar, varValue] =
                    getVarValue(children);
                  if (condVar)
                    children = varValue;

                  // ------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStls);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <RN.Text {...allProps} />
                  );
                },
                (...args) => {
                  // ---------- set Caps Inputs
                  const arrProps = [{}];
                  const arrStyles = [
                    { height: 30 },
                  ];
                  const varPath = 'true';
                  const varValue = 'true';
                  const children = [
                    () => {
                      return <></>;
                    },
                  ];

                  // ---------- set Arguments (If Exists)
                  let getValue = useData(ct =>
                    pathSel(ct, varPath)
                  );
                  const checkArgs =
                    varPath.startsWith('#');
                  if (checkArgs)
                    getValue = argSel(
                      args,
                      varPath
                    );

                  // ---------- set Conditional Element Render
                  const condRender =
                    getValue === varValue;

                  // ---------- set Variables Styles (If Exists)
                  const stl =
                    getStlValues(arrStyles);

                  // ------- set User Element Properties (If Exists)
                  const userElProps = {};

                  for (const object of arrProps) {
                    for (const keyProp in object) {
                      const valueProp =
                        object[keyProp];
                      userElProps[keyProp] =
                        valueProp;
                    }
                  }

                  const allProps = {
                    style: [stl],
                    children,

                    ...userElProps,
                  };

                  // ---------- set Render
                  return (
                    <>
                      {!condRender && <></>}
                      {condRender && (
                        <RN.View style={[stl]}>
                          {children.map(
                            (Item, idx) => (
                              <Item
                                key={idx}
                                {...args}
                              />
                            )
                          )}
                        </RN.View>
                      )}
                    </>
                  );
                },
                () => (
                  <RN.Text>{`Política de Privacidade de dados pessoais - Options Tecnologia\nA Options é uma plataforma preocupada com a Segurança e a Privacidade dos dados pessoais dos seus clientes e potenciais clientes, bem como com a transparência no tratamento dessas informações.\nEsta Política de Privacidade tem como objetivo esclarecer e informar a VOCÊ, nosso cliente ou potencial cliente, sobre as operações de tratamento de dados pessoais na Options, em conformidade com as leis e regulamentações vigentes.\nA Options coleta suas informações pessoais quando VOCÊ se registra em nosso site diretamente e também quando VOCÊ opta por assinar nosso serviço. A partir desses momentos, estaremos autorizados a realizar o tratamento dos seus dados pessoais, sempre com base no respeito, na segurança e na privacidade das suas informações.\nContinuamente aprimoramos nosso sistema e nossos processos internos de tratamento de dados pessoais. Por essa razão, esta Política de Privacidade está sempre sendo revisada e atualizada, a fim de mantermos nosso compromisso com a transparência no tratamento dos dados pessoais dos nossos clientes e potenciais clientes.\n\n - DADOS PESSOAIS:\nCom o intuito de viabilizar a prestação dos nossos serviços e aprimorar sua experiência em nossa plataforma, a Options coleta, de maneira geral, os seguintes dados pessoais:\nDESCRIÇÃO	TIPO\nInformações de identificação:	Nome completo, CPF e data de nascimento\nInformações de contato:	Telefone e e-mail\nInformações de autenticação:	Nome de usuário e senha\nInformações de localização	Endereço, número, complemento, bairro, CEP, cidade, estado e país:\nInformações eletrônicas	Cookies e dados de navegação (consulte nossa Política de Cookies):\nInformações bancárias	Banco, agência, número da conta, chave PIX, bandeira do cartão e número do cartão\n\n - FINALIDADE\nSeus dados pessoais são tratados pela Options exclusivamente para atender a finalidades específicas, em conformidade com as disposições da Lei 13.708/19 (LGPD), conforme explicado no quadro a seguir:\n\n\n\n\n\n\nDADO PESSOAL            FINALIDADE                      BASE LEGAL\n• Informações de identificação\n• Informações de contato\n• Informações de autenticação\n• Informações bancárias    Possibilitar a utilização da plataforma   Art. 7º, V e IX, Lei 13.709/18 (Execução dos termos de uso e interesse legítimo)\n• Informações de identificação\n• Informações de contato   Possibilitar o cadastro na plataforma    Art. 7º, V e IX, Lei 13.709/18 (Execução dos termos de uso e interesse legítimo)\n• Informações eletrônicas   Possibilitar uma experiência personalizada no site    Art. 7º, V e IX, Lei 13.709/18 (Execução dos termos de uso e interesse legítimo)\n• Informações de identificação\n• Informações de contato\n• Informações de localização    Cumprir a política comercial de market data da B3   Art. 7º, II e V, Lei 13.709/18 (Cumprimento de obrigação legal ou regulatória e execução dos termos de uso)\n• Informações de identificação\n• Informações de contato\n• Informações eletrônicas    Possibilitar campanhas de marketing, campanhas promocionais e oferta de período trial    Art. 7º, IX, Lei 13.709/18 (Interesse legítimo)\n• Informações de identificação\n• Informações de contato    Possibilitar o relacionamento com parceiros, liberação de períodos de teste em razão de parcerias e confirmação de cadastros de novos clientes vinculados às parcerias    Art. 7º, IX, Lei 13.709/18 (Interesse legítimo)\n• Informações de identificação\n• Informações de contato\n• Informações bancárias    Possibilitar atividades de suporte e atendimento ao cliente, consultas de clientes, abertura de chamados, reembolso e correção de dados cadastrais    Art. 7º, V e IX, Lei 13.709/18 (Execução dos termos de uso)\n• Informações de identificação\n• Informações de contato\n• Informações de autenticação\n• Informações de localização\n• Informações bancárias    Cumprir obrigação legal ou regulatória    Art. 7º, II, Lei 13.709/18 (Cumprimento de obrigação legal ou regulatória)\n• Informações de identificação\n• Informações de contato    Identificar possíveis falhas na plataforma relacionadas a um cliente específico    Art. 7º, IX, Lei 13.709/18 (Interesse legítimo)\n\n - COMPARTILHAMENTO\n\nA Options não divulga os dados pessoais dos seus clientes e potenciais clientes. O compartilhamento das suas informações pessoais ocorre apenas para o cumprimento de obrigações legais/regulatórias ou quando for essencial para a execução dos serviços oferecidos pela plataforma, sempre dentro dos limites estabelecidos nesta Política de Privacidade.\n\nSeus dados pessoais poderão ser compartilhados com: (i) órgãos controladores e autoridades regulatórias ou judiciais; (ii) prestadores de serviços e consultores especializados; (iii) provedores de serviços de pagamento (tokenização); (iv) parceiros; (v) serviços de armazenamento em nuvem.\n\nNessas situações em que o compartilhamento dos seus dados pessoais é necessário, a Options se preocupa em exigir que terceiros adotem medidas de segurança adequadas, tanto técnicas quanto administrativas, para proteger suas informações pessoais contra acesso não autorizado, destruição, perda, alteração, divulgação ou qualquer forma de tratamento inadequado ou ilegal.\n\n - TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS\nA Options realiza o tratamento dos dados pessoais dos seus clientes e potenciais clientes apenas em território nacional, não havendo transferência internacional de dados.\n - CONSENTIMENTO E REVOGAÇÃO DO CONSENTIMENTO\nCaso seja necessário obter o seu consentimento para legitimar o tratamento de determinados dados pessoais, ele será solicitado oportunamente na própria área logada da plataforma, de forma livre, inequívoca e informada.\nVocê tem o direito de revogar seu consentimento a qualquer momento. Para isso, basta enviar uma solicitação por e-mail para o Encarregado de Dados da Options, através do seguinte endereço: contato@investtv.com.br.\n - ARMAZENAMENTO\nA Options se compromete em garantir que as informações pessoais dos seus clientes e potenciais clientes sejam armazenadas de maneira segura, visando proteção, privacidade, integridade, disponibilidade e confidencialidade. Para isso, são utilizadas as melhores técnicas de segurança da informação, a fim de reduzir a vulnerabilidade de incidentes nos ambientes digitais.\nNo entanto, a segurança das suas informações pessoais também depende da segurança do seu computador, dispositivo ou rede, além do nível de segurança que você utiliza para proteger seus dados de autenticação (login e senha). Portanto, é sua responsabilidade pessoal gerenciar suas informações.\nVII - RETENÇÃO\nSeus dados pessoais serão armazenados pela Options enquanto a sua conta estiver ativa e por um período de até 5 (cinco) anos após a inatividade da sua conta, de acordo com as finalidades de cumprimento de obrigações legais ou regulatórias mencionadas nesta Política de Privacidade.\nVIII - DIREITOS DOS TITULARES DE DADOS\nA Lei Geral de Proteção de Dados (LGPD) - Lei 13.709/18 estabelece direitos aos titulares de dados, os quais são listados no artigo 18 dessa lei.\nA Options se preocupa em garantir que esses direitos sejam conhecidos e exercidos por seus clientes e potenciais clientes. Para isso, temos um Encarregado de Dados responsável pela comunicação entre a Options e você.\nSe você deseja entrar em contato com a Options para tratar assuntos relacionados aos seus dados pessoais, basta enviar um e-mail para: contato@investtv.com.br.`}</RN.Text>
                ),
              ];

              // ---------- set Render
              return (
                <RN.ScrollView>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.ScrollView>
              );
            },
          ];

          // ---------- set Arguments (If Exists)
          let getValue = useData(ct =>
            pathSel(ct, varPath)
          );
          const checkArgs =
            varPath.startsWith('#');
          if (checkArgs)
            getValue = argSel(args, varPath);

          // ---------- set Conditional Element Render
          const condRender =
            getValue === varValue;

          // ---------- set Variables Styles (If Exists)
          const stl = getStlValues(arrStyles);

          // ------- set User Element Properties (If Exists)
          const userElProps = {};

          for (const object of arrProps) {
            for (const keyProp in object) {
              const valueProp = object[keyProp];
              userElProps[keyProp] = valueProp;
            }
          }

          const allProps = {
            style: [stl],
            children,

            ...userElProps,
          };

          // ---------- set Render
          return (
            <>
              {!condRender && <></>}
              {condRender && (
                <RN.View style={[stl]}>
                  {children.map((Item, idx) => (
                    <Item key={idx} {...args} />
                  ))}
                </RN.View>
              )}
            </>
          );
        },
      ];
      const arrFunctions = [() => {}];

      // ---------- call Functions (If Exists)
      React.useEffect(() => {
        const callFn = async () => {
          for (const currFunc of arrFunctions)
            await currFunc(...args);
        };
        callFn().catch(err =>
          console.log({ err })
        );
      }, []);

      // ---------- set Variables Styles (If Exists)
      const stl = getStlValues(arrStyles);

      // ---------- set Render
      return (
        <RN.View style={[stl]}>
          {children.map((Item, idx) => (
            <Item key={idx} />
          ))}
        </RN.View>
      );
    },
  },
];

const config = () => ({
  // ----------- set zustand Variables
  vars() {
    const useData = create(() => ({ ...initCt }));

    const setData = ({ path, value }) => {
      return useData.setState(ct => {
        const newObj = { ...ct };

        const setVal = (prev, curr, i, arr) => {
          const condNext = arr[i + 1];
          const condSelItem = () =>
            prev[curr] || (prev[curr] = {});
          const newVal = () =>
            (prev[curr] = value);
          const condVal = condNext
            ? condSelItem()
            : newVal();
          return condVal;
        };

        path.split('.').reduce(setVal, newObj);

        return newObj;
      });
    };

    const getCtData = path => {
      const ct = useData.getState();
      const varValue = pathSel(ct, path);
      return varValue;
    };

    return { useData, setData, getCtData };
  },
});

const utils = () => ({
  // ---------- set GoTo Router (with All Screens Access)
  goTo: newRoute =>
    useRoutes.setState({ currRoute: newRoute }),

  // ----------- set Variable Selection
  getVarValue(path) {
    const checkString = typeof path !== 'string';
    if (checkString) return [false, null];

    const condBool =
      path.includes('{{') && path.includes('}}');
    if (!condBool) return [false, null];

    const varPath = path
      .replace('{{', '')
      .replace('}}', '');
    const varValue = useData(ct =>
      pathSel(ct, varPath)
    );

    return [true, varValue];
  },

  // ----------- set Path Selection
  pathSel(obj, path) {
    const pathArr = path.split('.');

    const reduceCb = (p, c) => {
      const checkNum = Number(c);
      const condNum =
        checkNum === 'NaN' ? c : checkNum;

      return p && p[c];
    };
    const valueSel = pathArr.reduce(
      reduceCb,
      obj
    );

    return valueSel;
  },

  // ----------- set Style Variable Selection
  getStlValues(arrGetValues) {
    const allStls = arrGetValues.flatMap(
      style => {
        const possibleValues = Object.keys(style);

        const result = possibleValues.flatMap(
          key => {
            const stlVal = style[key];
            const [condVar, varValue] =
              getVarValue(stlVal);
            if (!condVar)
              return { [key]: stlVal };
            if (!varValue) {
            }
            return { [key]: varValue };
          }
        );

        return result;
      }
    );

    const stlReturn =
      RN.StyleSheet.flatten(allStls);
    return stlReturn;
  },

  // ----------- set Arguments Selection
  argSel(args, inputStr) {
    const arrTerms = inputStr.split('.')[0];
    const argsIdx = arrTerms.replace('#', '');
    const valueArg = args[argsIdx];
    const path = inputStr.replace(
      arrTerms + '.',
      ''
    );

    const argSel = pathSel(valueArg, path);
    return argSel;
  },
});

// ---------- set Project Functions
const { useData, setData, getCtData } =
  config().vars();
const {
  goTo,
  getVarValue,
  pathSel,
  getStlValues,
  argSel,
} = utils();

// ---------- set Project Router
const Router2 = () => (
  <div style={{ color: 'white' }}>Olá</div>
);

const Router = () => {
  // ---------- set Router State
  const currRoute = useRoutes(
    stt => stt.currRoute
  );

  // ---------- set Hooks
  const currWidth =
    RN.useWindowDimensions().width;
  React.useEffect(() => {
    setData({
      path: 'common.screen.currWidth',
      value: currWidth,
    });
  }, [currWidth]);

  // ---------- set Current Screen Selection
  let CurrScreen;
  screensArr.forEach(item => {
    const checkPath =
      item.screenData.path === currRoute;
    const Screen = item.Screen;
    if (checkPath) CurrScreen = () => <Screen />;
  });

  // ---------- set First Screen to avoid Error
  if (!CurrScreen) {
    CurrScreen = () => {
      const FirstScreen = screensArr[0].Screen;
      return <FirstScreen />;
    };
  }

  // ---------- set Return
  return <CurrScreen />;
  return (
    <div style={{ color: 'white' }}>Olá</div>
  );
  return (
    <RN.SafeAreaView style={{ flex: 1 }}>
      {RN.Platform.OS !== 'web' && (
        <RN.View
          style={{
            height: 30,
            backgroundColor: '#0067a5',
          }}
        />
      )}
      <CurrScreen />
      <StatusBar style="light" />
    </RN.SafeAreaView>
  );
};

export { Router };
